import "../style/SetUpBox.css";
import { Link } from "react-router-dom";
import { GAME_OPTIONS_PATH } from "../../../../../constants";

export default function SetUpBox({unit, category, setPageState, gamestate, setGameState}) {
    const difficulties = ['easy', 'medium', 'hard'];

    return (
        <div className="setup-container">
            <button
                type="button"
                className="help-button"
                onClick={() => setPageState("tutorial")}
                aria-label="Open Jump Rope tutorial"
            >
                ?
            </button>

            <h1>{unit.name}</h1>
            <div className="pregame-div">
                <h2>Jump Rope Game</h2>
                <div className="settings-div">
                    <b>Difficulty Level:</b>

                    {difficulties.map((difficulty) => (
                        <div key={difficulty} className="difficulty-option">
                            <input
                                type="radio"
                                id={difficulty}
                                name="difficulty"
                                value={difficulty}
                                checked={difficulty === gamestate.difficulty}
                                onChange={(event) => setGameState({...gamestate, difficulty: event.target.value})}
                            />
                            <label htmlFor={difficulty}>{difficulty.charAt(0).toUpperCase() + difficulty.slice(1)}</label>
                        </div>
                    ))}

                </div>

                <button className="btn btn-primary" onClick={() => setPageState("gameplay")}>
                    Start Game
                </button>
            </div>

            <Link
                to={GAME_OPTIONS_PATH}
                state={{ unit: unit, category: category }}
                className="game-options-back-link"
            >
                <button className="btn btn-back game-options-back-button">Back</button>
            </Link>
        </div>
    );
}
